import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';

function UserInfo({ user }) {
  const [form, setForm] = useState({
    first_name: '',
    middle_name: '',
    last_name: '',
    email: '',
    employee_id: '',
  });

  useEffect(() => {
    if (user) {
      setForm({
        first_name: user.first_name || '',
        middle_name: user.middle_name || '',
        last_name: user.last_name || '',
        email: user.email || '',
        employee_id: user.employee_id || '',
      });
    }
  }, [user]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    Swal.fire('Info', 'Update functionality is temporarily disabled.', 'info');
  };

  return (
    <div className="form-container">
      <h2>User Information</h2>
      <form onSubmit={handleSubmit}>
        <label>First Name</label>
        <input
          name="first_name"
          type="text"
          value={form.first_name}
          onChange={handleChange}
          disabled
        />

        <label>Middle Name</label>
        <input
          name="middle_name"
          type="text"
          value={form.middle_name}
          onChange={handleChange}
          disabled
        />

        <label>Last Name</label>
        <input
          name="last_name"
          type="text"
          value={form.last_name}
          onChange={handleChange}
          disabled
        />

        <label>Email</label>
        <input
          name="email"
          type="email"
          value={form.email}
          onChange={handleChange}
          disabled
        />

        <label>Employee ID</label>
        <input
          name="employee_id"
          type="text"
          value={form.employee_id}
          onChange={handleChange}
          disabled
        />

        {/* <button type="submit" disabled>Update Info</button> */}
      </form>
    </div>
  );
}

export default UserInfo;
